import { Instance, types } from 'mobx-state-tree';

const ChatGroup = types.model('ChatGroup', {
	id: types.identifierNumber,
	name: types.optional(types.string, ''),
	official_name: types.optional(types.string, ''),
});

export default ChatGroup;

export interface IChatGroupModel extends Instance<typeof ChatGroup> {}
